module.exports = __webpack_public_path__ + "img/album14_27.a2b4f6f8.jpg";